// Muss der erste Import sein: Zod ohne JIT, bevor irgendein Schema entsteht (RW-E-15)
import '@/zod-config';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/app/app';
import { installChunkReload } from '@/app/chunk-reload';
import { createAppRouter } from '@/app/router';
import './index.css';

// Alter Tab nach einem Deploy: fehlendes Seitenbündel → einmal neu laden (vor dem ersten dynamischen Import)
installChunkReload();

const container = document.getElementById('root');
if (container === null) {
  throw new Error('Wurzelelement #root fehlt');
}

// Mock-Modus (Entwicklung, E2E): dynamischer Import hinter dem Schalter, damit das Produktionsbündel
// keinen Mock-Code enthält (der Vergleich wird beim Bauen zu einer Konstanten).
if (import.meta.env.VITE_API_MOCK === '1') {
  const { startMock } = await import('@/api/mock/browser');
  await startMock(window.location.search);
}

createRoot(container).render(
  <StrictMode>
    <App router={createAppRouter()} />
  </StrictMode>,
);
